import { defineStore } from "pinia";

export const useNotificationsStore = defineStore("notifications", {
  state: () => ({
    lastNotification: null,
  }),

  actions: {
    showSuccessNotification(message) {
      this.lastNotification = {
        timeout: 3000,
        position: "center",
        color: "success",
        text: message,
      };
    },

    showErrorNotification(message) {
      this.lastNotification = {
        timeout: 3000,
        position: "center",
        color: "error",
        text: message,
      };
    },
    showWarningNotification(message) {
      this.lastNotification = {
        timeout: 3000,
        position: "center",
        color: "warning",
        text: message,
      };
    },
  },
});
